module.exports = __webpack_public_path__ + "static/img/h15.bab8cd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/h15.jpg
// module id = 4VGi
// module chunks = 0